export default __webpack_public_path__ + "locales/sr-Cyrl-RS/PeopleTranslations.json?hash=3f51b0c48306c1f59e8127338dc711fc";